// extracted by mini-css-extract-plugin
export default {"contentButtons":"styles_contentButtons__BjBI-"};